<template lang="pug">
  .container-test.container-padding
    c-header
      template(slot="left")
        h3 交易流水
    c-box
      el-form(:model="filters",label-position="right",label-width="100px")
        el-row(:gutter="10")
          el-col(:span="16")
            el-form-item(label="订单日期")
              el-date-picker(v-model="bill_date", type="daterange", placeholder="选择日期范围")
          el-col(:span="8")
            el-form-item(label="单据类型")
              el-select(v-model="filters.bill_type")
                el-option(:value="null", label="所有")
                el-option(v-for="a in 4", :key="a", :value="a", :label="a | billType")
        el-row(:gutter="10")
          el-col(:span="8")
            el-form-item(label="交易号")
              el-input(v-model="filters.bill_id")
            el-form-item(label="")
              el-button(@click="setFilter", type="primary") 搜索
              el-button(@click="timeReset") 重置日期范围
              el-button(@click="clearFilter", v-show="hasFilter") 清除
          el-col(:span="8")
            el-form-item(label="业务订单号")
              el-input(v-model="filters.out_trade_no")
            el-form-item(label="")
              el-button(@click="toExport", type="primary") 导出流水报表
          el-col(:span="8")
            el-form-item(label="收款账号 ID")
              el-input(v-model="filters.account_id")
    c-box
      el-table(:data="list", fit, v-loading="listLoading", size="small", border)
        el-table-column(property="create_time", label="创建时间", min-width="150", show-tooltip-when-overflow)
        el-table-column(label="单据类型", width="75", align="center", v-slot="{ row }")
          template {{ row.bill_type | billType }}
        el-table-column(property="subject", label="订单名称", min-width="150", show-tooltip-when-overflow)
        el-table-column(label="收款账户／交易号", min-width="250", show-tooltip-when-overflow, v-slot="{ row }")
          .line-height-1
            .display-block {{ row.account_name }}
            .display-block {{ row.bill_id }}
        el-table-column(label="业务／业务订单号", min-width="200", show-tooltip-when-overflow, v-slot="{ row }")
          .line-height-1
            .display-block {{ row.app_name }}
            .display-block {{ row.out_trade_no }}
        el-table-column(label="单据总额", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.trade_amount | toYuan }}
        el-table-column(label="平台手续费", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.fee_amount | toYuan }}
        el-table-column(label="实收金额", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.bussiness_receipt_amount | toYuan }}
        el-table-column(label="单据状态", width="75", v-slot="{ row }") {{ row.bill_type | bill_status }}
        el-table-column(label="操作", min-width="100", align="right", v-slot="{ row }")
          .row-toolbox
            el-button(type="primary", @click="showDetail(row)") 详情

    el-dialog(title="交易流水详情", :visible.sync="detail.show")
      el-form(:model="detail.source", label-position="right", label-width="125px")
        el-form-item(label="业务订单号") {{ detail.source.out_trade_no }}
        el-form-item(label="单据类型") {{ detail.source.bill_type | billType }}
        el-form-item(label="交易号") {{ detail.source.bill_id }}
        el-form-item(label="单据创建时间") {{ detail.source.create_time }}
        el-form-item(label="交易成功时间") {{ detail.source.success_time }}
        el-form-item(label="支付通道") {{ detail.source.proxy_channel | proxyChannel }}
        el-form-item(label="业务") {{ detail.source.app_name }}
        el-form-item(label="账户") {{ detail.source.account_name }}
        el-form-item(label="单据总金额") {{ detail.source.trade_amount | toYuan }}
        el-form-item(label="平台手续费") {{ detail.source.fee_amount | toYuan }}
        el-form-item(label="商家实收金额") {{ detail.source.bussiness_receipt_amount | toYuan }}
        el-form-item(label="商品标题") {{ detail.source.subject }}
        el-form-item(label="商品描述") {{ detail.source.body }}
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="hideDetail()") 关闭
</template>

<script>
export default {
  data () {
    return {
      page:   1,
      size:   20,
      status: 0,
      list:   [],
      total:  0,

      listLoading:  false,

      filters: {
        account_id:     null,
        bill_type:      null,
        bill_id:        null,
        out_trade_no:   null,
      },
      bill_date:    [],
      hasFilter:    false,

      detail:   {
        show:     false,
        source:   {},
      },
    };
  },
  filters: {
    bill_status (source) {
      if (!source && source !== 0) {
        return '-';
      }
      switch (parseInt(source)) {
        case 1: return '支付成功';
        case 2: return '退款成功';
        default: return source;
      }
    },
  },
  methods: {
    showDetail (row) {
      this.detail = {
        show:     true,
        source:   Object.assign({}, row),
      };
    },
    hideDetail () {
      this.detail = {
        show:     false,
        source:   {},
      };
    },

    toExport () {
      const params = Object.assign({}, this.filters, {
        from_bill_date: (Array.isArray(this.bill_date) && typeof this.bill_date[0] !== 'undefined') ? this.$dateFormatter(this.bill_date[0]) : null,
        to_bill_date:   (Array.isArray(this.bill_date) && typeof this.bill_date[1] !== 'undefined') ? this.$dateFormatter(this.bill_date[1]) : null,
      });

      this.$message({
        type:     'info',
        message:  `正在生成报表，请稍后……`,
      });
      this.$store.dispatch('EXPORT_PAY_RECORD_FLOW_LIST', params).then(({ location }) => {
        console.log(location);
        window.open(location);
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `报表生成失败。${code}：${msg}`,
        });
      });
    },

    timeReset () {
      this.bill_date = [];
      this.refresh();
    },
    setFilter () {
      if (this.filters.account_id || this.filters.bill_type || this.filters.bill_id ||
        this.filters.out_trade_no || (Array.isArray(this.filters.bill_date) && this.filters.bill_date === 2)) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.getList(1);
    },
    clearFilter () {
      this.filters = {
        account_id:     null,
        bill_type:      null,
        bill_id:        null,
        out_trade_no:   null,
      };
      this.bill_date = [];
      this.hasFilter = false;
      this.getList(1);
    },
    refresh () {
      this.getList(this.page);
    },
    changeListSize (size = 20) {
      this.size = size;
      this.getList(1);
    },

    getList (page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters, {
        from_bill_date: (Array.isArray(this.bill_date) && typeof this.bill_date[0] !== 'undefined') ? this.$dateFormatter(this.bill_date[0]) : null,
        to_bill_date:   (Array.isArray(this.bill_date) && typeof this.bill_date[1] !== 'undefined') ? this.$dateFormatter(this.bill_date[1]) : null,
      });
      this.$store.dispatch('GET_PAY_RECORD_FLOW_LIST', Object.assign({
        offset:   this.size * (this.page - 1),
        limit:    this.size,
        stat:     true,
      }, _filters)).then((data) => {
        this.list = data.list;
        this.total = data.total;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },
  },
  mounted () {
    this.getList(1);
  },
};
</script>

<style lang="less">

</style>